import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

export function ExpedienteNotFound({businessId, year}: {businessId: string; year: number}) {
  const {t} = useTranslation()
  const currentYear = new Date().getFullYear()
  return (
    <div className="space-y-4" data-testid="expediente-not-found">
      <p className="text-sm text-muted-foreground">{t('expediente.notFound', {year})}</p>
      <Link to={`/businesses/${businessId}/sgsst`} className="text-sm text-primary hover:underline">
        {t('expediente.back', {year: currentYear})}
      </Link>
    </div>
  )
}

/** El año se selló antes de que existieran los snapshots: no se inventan datos. */
export function ExpedienteEmptySnapshot({message}: {message: string}) {
  const {t} = useTranslation()
  return (
    <div data-testid="expediente-snapshot-ausente" className="surface flex flex-col gap-1 px-4 py-6 text-center">
      <span className="font-mono text-[11px] font-semibold tracking-wider text-muted-foreground uppercase">
        {t('expediente.snapshotAusente.titulo')}
      </span>
      <span className="text-sm text-muted-foreground">{message}</span>
    </div>
  )
}
